import { Text, Box, IconInfoInverted, Inline } from '@machobear/design-system'

interface Props {
  children: React.ReactNode
  icon?: 'info'
  [key: string]: any
}
const InfoBox = ({ children, icon = 'info', ...rest }: Props) => {
  return (
    <Box display="flex" gap="xxsmall" alignItems="center" {...rest}>
      <Inline space="none">
        {icon === 'info' && <IconInfoInverted size="xsmall" tone="info" />}
      </Inline>
      <Text size="small" tone="info" weight="regular">
        {children}
      </Text>
    </Box>
  )
}

export default InfoBox
